import React from "react";
import { Spin } from "antd";

import { StyledModal } from "./styles";

import Loader from "../Loader";

const Modal = ({
  children,
  open,
  onCancel,
  title,
  loading = false,
  onOk,
  footer,
  width,
  ...rest
}) => (
  <StyledModal
    title={title}
    centered
    open={open}
    onCancel={onCancel}
    onOk={onOk}
    okButtonProps={{ loading }}
    footer={
      footer && (
        <Spin spinning={loading} indicator={<span />}>
          {footer}
        </Spin>
      )
    }
    width={width}
    {...rest}
  >
    <Spin spinning={loading} indicator={<Loader />}>
      {children}
    </Spin>
  </StyledModal>
);

export default Modal;
